<template>
  <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">

    <div class="toaster" :id="responseMessageType" v-show="responseMessage">{{responseMessage}}</div>

    <app-slack
      v-on:hideOverlay="showOrHide(false)"
      v-on:showResponse="showMessage"
      v-on:end="end"
      v-show="showSlack"
      :profile="profile" />

    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1 class="text-center view-profile" v-on:click="toggleProfile()">{{getIntroduction()}}</h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Chat History</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <!-- Small boxes (Stat box) -->
      <div class="row">
        <!-- ./col -->

        <div class="loader" v-if="loading">
          <img src="/static/img/loader.gif" />
        </div>
        <div class="col-xs-12" v-if="!loading">
          <app-profile
            v-show="showProfile"
            :profile="profile"
            :supportedLanguages="supportedLanguages"
            v-if="profile"
            v-on:close="toggleProfile"
            v-on:show="showMessage" />
          <div class="col-xs-12 col-sm-8 col-sm-offset-2 chat">
            <h3 v-show="!history.length">No chat history found</h3>
            <div class="conversation">
              <div v-for="(each, index) in history" :key="index">
                <span v-show="each.type == 'user'">{{formatTime(each.time)}}</span>
                <span class="response-time" v-show="each.type == 'agent'">{{each.agent}} - {{formatTime(each.time)}}</span><br/>
                <p v-show="each.message" :class="each.type" v-html="formatResponse(each.message)"></p>
                <app-bot
                  v-if="each.message && each.bot"
                  :bot="setBotResponse(each.bot)"
                  :botIntent="each.intent"
                  :botLanguage="each.language"
                  :index="index"
                  :entities="each.entities"
                  v-on:showResponse="showMessage"
                  v-on:classify="classify" />
                <br v-show="each.type == 'agent'" clear="all" />
              </div>
            </div>

            <br />
            <form class="form-inline response-action" v-on:submit.prevent="sendMessage">
              <div class="form-group response-message">
                <textarea v-on:focus="readChat()" :readonly="sending || (isBotResponse && !botSuggestionDetails)" v-model="message" class="form-control text" placeholder="Message"></textarea>
              </div>
              <button type="submit" class="btn btn-primary" :disabled="sending">{{sending ? 'Sending...' : 'Send'}}</button>
              <button type="button" class="btn btn-primary" v-on:click="showOrHide(true)">More</button>
              <button type="button" class="btn btn-danger" v-on:click="end()" :disabled="sending">End</button>
            </form>
            <br />
            <app-suggestion
              v-on:setMessage="setMessage"
            />
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import moment from 'moment-timezone';
  import io from 'socket.io-client';
  import { mapState, mapActions } from 'vuex';
  import Profile from './profile';
  import Slack from './Slack';
  import Bot from './bot';
  import Suggestion from './suggestion';
  import { logout, getUser } from '../../utils/auth';
  import api from '../../utils/api';
  import constantHelper from '../../utils/constantHelper';

  export default {
    name: 'Chat',
    components: {
      'app-profile': Profile,
      'app-slack': Slack,
      'app-bot': Bot,
      'app-suggestion': Suggestion
    },
    methods: {
      formatResponse(res) {
        if (res) {
          // const re = new RegExp("SMS\d - ", 'gi');
          const response = String(res);
          const message = response.replace('SMS1 - ', '');
          return message.replace(/SMS\d - /gi, '<br /><br />');
        }
        return '';
      },

      formatTime(time) {
        let responseDate = moment(time, 'YYYY-MM-DD h:mm A').format('MM-DD-YYYY');
        responseDate = responseDate === moment().tz('Africa/Nairobi').format('MM-DD-YYYY')
                            ? moment(time, 'YYYY-MM-DD h:mm A').format('h:mm A')
                            : moment(time, 'YYYY-MM-DD h:mm A').format('YYYY MMM DD, h:mm A');
        return responseDate;
      },

      sendMessage() {
        this.readChat();
        this.fireSms(this.message, this.$route.params.accountid, this.agent);
        this.scrollToEnd();
      },

      end() {
        this.fireSms('end', this.$route.params.accountid);
      },

      /**
       * @function fireSms
       * @description send chat message to the user
       * @param {string} message the message to be sent to the user
       * @param {string} phoneNumber the accountid of the user (+) sign inclusive
       * @param {string} agent name of the agent that sent the message
       */
      async fireSms(message, phoneNumber, agent = null) {
        this.sending = true;
        try {
          const { status, data } = await this.fireSmsAction({
            message,
            phoneNumber,
            username: agent || '',
            country: this.profile.country,
            botSuggestionDetails: this.botSuggestionDetails,
            ...this.frequentlyUsedDetails
          });
          if (status === 200) {
            this.resetFields(['message']);
            this.setFrequentlyUsedDetails({});
          }
          this.showMessage(data.payload, status === 200 ? 'success' : 'error');
          this.botSuggestionDetails = null;
          this.isBotResponse = false;
        } catch (error) {
          this.showMessage('An error occurred', 'error');
        } finally {
          this.sending = false;
        }
      },

      getIntroduction() {
        if (this.profile && this.history.length) {
          let intro = this.profile._id;
          const properties = ['name', 'gender', 'age', 'language', 'location', 'usertype'];
          const failedScreening = (this.profile.screening && this.profile.screening.module &&
            !this.profile.screening.result) ? ' Failed screening' : '';
          properties.forEach((eachProperty) => {
            intro += this.profile[eachProperty] ? ` - ${this.profile[eachProperty]}` : '';
          });
          intro += (this.profile.referrals.length)
            ? ` - ${this.profile.referrals[this.profile.referrals.length - 1].code}`
            : '';
          intro += failedScreening;
          return intro;
        }
        return '';
      },

      showMessage(message, messageType, logoutUser) {
        this.responseMessage = message;
        this.responseMessageType = messageType;
        setTimeout(() => this.clearMessage(logoutUser), 5000);
      },

      /**
       * @function clearMessage
       * @description hide the toast message after a specified amount of seconds
       * @param {boolean} logUserOut - if true the user will be logged out
       */
      clearMessage(logUserOut = false) {
        this.responseMessage = '';
        this.responseMessageType = '';
        if (logUserOut) {
          logout();
        }
      },

      scrollToEnd() {
        const conversation = document.querySelector('.conversation');
        setTimeout(() => {
          conversation.scrollTop = conversation.scrollHeight;
        }, 0);
      },

      /**
       * @function getMessages
       * @description listens to the incoming message event or new messages
       * @description coming for a user
       */
      getMessages() {
        const socket = window.location.host.includes('localhost') ? io('http://localhost:3000') : io();
        socket.on('incoming-message', (details) => {
          this.handleIncomingMessage(details);
        });

        socket.on(this.agent, (details) => {
          this.handleIncomingMessage(details);
        });
      },

      /**
       * @function handleIncomingMessage
       * @description handles new incoming messages
       * @param {Object} details the socket full details
       */
      handleIncomingMessage(details) {
        if (this.$route.params.accountid === details.user) {
          const time = details.time || moment().tz('Africa/Nairobi').format('YYYY-MM-DD h:mm A');
          this.addNewMessage({ ...details, time });
          this.scrollToEnd();
        }
      },

      async loadInitialMessages(phoneNumber) {
        try {
          await this.retrieveMessages(phoneNumber);
          this.loading = false;
          setTimeout(() => {
            this.scrollToEnd();
          }, 0);
        } catch (error) {
          this.showMessage('Could not load chat, please check your internet', 'error', false);
        }
      },

      readChat() {
        const socket = window.location.host.includes('localhost') ? io('http://localhost:3000') : io();
        socket.emit('read-chat', {
          user: this.$route.params.accountid
        });
      },

      /**
       * @function resetFields
       * @description sets a form field to '' (empty string)
       * @param {Array<String>} fields - an array of all field names in data to reset
       */
      resetFields(fields) {
        fields.forEach((each) => {
          this[each] = '';
        });
      },

      showOrHide(value) {
        this.showSlack = value;
      },

      toggleProfile() {
        this.showProfile = !this.showProfile;
      },

      /**
       * @function classify
       * @description approve or reject wit.ai suggestions
       * @param {number} index - the message index
       * @param {string} intent - the intent chosen by the agent
       * @param {string} message - the new bot message
       * @param {string} language - the bot message language
       * @param {boolean} newIntentFlag - if an agent manually entered an intent
       */
      classify(index, intent, message, language, newIntentFlag) {
        this.botSuggestionDetails = {
          index,
          intent,
          language,
          newIntentFlag
        };
        this.message = message;
        this.modifyMessage({
          index,
          update: { ...this.history[index], bot: null }
        });
      },

      /**
       * @function setBotResponse
       * @description check if there is a bot message and set isBotResponse to true if true
       * @param {string} message - the bot message from wit.ai
       */
      setBotResponse(message) {
        if (message) {
          // this will ensure that the bot suggestion is either accepted or rejected
          this.isBotResponse = true;
        }
        return message;
      },
      setMessage(message) {
        this.message = message;
      },
      /**
       * @function getSupportedLanguages
       * @description function to get supported languages based on country / domain
       */
      getSupportedLanguages() {
        const domain = window.location.hostname;
        let country = 'India';
        if (this.profile) {
          if (this.profile.country) {
            country = this.profile.country;
          } else {
            country = constantHelper.constants.countryDomain[domain];
          }
        } else {
          country = constantHelper.constants.countryDomain[domain];
        }
        // eslint-disable-next-line no-console
        // console.log(currentUrl);
        // const country = 'India';
        api.buildRequest(`supportedlanguages/${country}`, 'GET')
          .then((response) => {
            // eslint-disable-next-line no-console
            console.log('supportedLanguages response');
            // eslint-disable-next-line no-console
            console.log(response);
            this.supportedLanguages = response.data.payload;
          }).catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      },
      ...mapActions([
        'retrieveMessages',
        'fireSmsAction',
        'addNewMessage',
        'modifyMessage',
        'setFrequentlyUsedDetails'
      ])
    },
    data() {
      return {
        loading: true,
        message: '',
        isBotResponse: false,
        botSuggestionDetails: null,
        responseMessage: '',
        responseMessageType: '',
        sending: false,
        showSlack: false,
        showProfile: false,
        // supportedLanguages: [{
        //   alias: 'eng',
        //   iso2: 'en',
        //   iso3: 'eng',
        //   name: 'English',
        //   defaultLang: 'eng'
        // },
        // {
        //   alias: 'swa',
        //   iso2: 'sw',
        //   iso3: 'swa',
        //   name: 'Swahili',
        //   defaultLang: 'eng'
        // }
        // ],
        agent: getUser().nickname
      };
    },
    mounted() {
      this.loadInitialMessages(this.$route.params.accountid);
      this.getMessages();
      // make an api call to retrieve
      if (!this.profile) {
        this.getSupportedLanguages();
      }
    },
    computed: mapState({
      history: state => state.chat.history,
      profile: state => state.profile.profile,
      frequentlyUsedDetails: state => state.general.frequentlyUsedDetails
    }),
    watch: {
      $route(to) {
        this.loading = true;
        this.isBotResponse = false;
        this.message = '';
        this.loadInitialMessages(to.params.accountid);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/chat/index.vue